import { Star, Quote } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { REVIEWS } from "../../lib/content";
import { useLang } from "../../lib/i18n";

const Stars = () => (
  <div className="flex gap-1 mb-4" aria-label="5/5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={14} className="fill-[#c9a24b] text-[#c9a24b]" />
    ))}
  </div>
);

export const Reviews = () => {
  const { tr } = useLang();
  return (
    <section
      id="recensioni"
      data-testid="reviews-section"
      className="relative bg-ad-black py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-20">
          <Reveal>
            <Overline>{tr("Recensioni · Google", "Reviews · Google")}</Overline>
            <h2 className="mt-6 font-serif-display font-light text-4xl md:text-6xl leading-none tracking-tight text-white max-w-2xl">
              {tr("Le parole delle", "The words of")}{" "}
              <span className="italic text-gold">{tr("nostre spose", "our brides")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div
              data-testid="google-rating-badge"
              className="flex items-center gap-4 border border-white/15 px-6 py-4"
            >
              <span className="font-serif-display text-4xl text-white leading-none">
                5,0
              </span>
              <div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={13}
                      className="fill-[#c9a24b] text-[#c9a24b]"
                    />
                  ))}
                </div>
                <span className="font-sans-ui text-[11px] uppercase tracking-[0.2em] text-white/60">
                  {tr("Recensioni verificate", "Verified reviews")}
                </span>
              </div>
            </div>
          </Reveal>
        </div>

      </div>

      {/* Auto-scrolling carousel (full-bleed) */}
      <div
        data-testid="reviews-carousel"
        className="group relative mt-4 w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_5%,black_95%,transparent)]"
      >
        <div className="flex w-max gap-6 animate-review-marquee group-hover:[animation-play-state:paused]">
          {[...REVIEWS, ...REVIEWS].map((r, i) => (
            <div
              key={i}
              data-testid={`review-card-${i}`}
              className="w-[290px] md:w-[380px] shrink-0 self-stretch flex"
            >
              <div className="group/card relative flex flex-col bg-ad-surface border border-white/10 p-7 md:p-8 hover:border-gold/40 transition-colors duration-500">
                <Quote size={26} className="text-gold/30 mb-4" />
                <Stars />
                <p className="font-sans-ui font-light text-white/75 leading-relaxed text-[15px]">
                  {tr(r.text, r.textEn)}
                </p>
                <div className="mt-6 flex items-center gap-3">
                  <span className="hairline w-8" />
                  <span className="font-serif-display text-lg text-white">
                    {r.name}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10">

        <Reveal delay={0.1}>
          <p className="mt-12 font-sans-ui font-light text-sm text-white/40 text-center">
            {tr(
              "Recensioni raccolte dai profili verificati Google di Atelier Divine.",
              "Reviews collected from Atelier Divine's verified Google profiles."
            )}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
